import { forwardRef, type ReactNode } from 'react';

// material-ui
import { Card, CardContent, CardHeader, Divider, Typography, type SxProps, type Theme } from '@mui/material';

const headerSX = {
  '& .MuiCardHeader-action': { mr: 0 }
};

export interface MainCardProps {
  border?: boolean;
  boxShadow?: boolean;
  children?: ReactNode;
  content?: boolean;
  contentClass?: string;
  shadow?: string;
  sx?: SxProps<Theme>;
  title?: ReactNode | string;
}

// ==============================|| CUSTOM MAIN CARD ||============================== //

const MainCard = forwardRef<HTMLDivElement, MainCardProps>(
  ({ border = true, boxShadow, children, content = true, contentClass = '', shadow, sx = {}, title, ...others }, ref) => (
    <Card
      ref={ref}
      {...others}
      sx={{
        border: border ? '1px solid' : 'none',
        ':hover': {
          boxShadow: boxShadow ? shadow || '0 2px 14px 0 rgb(32 40 45 / 8%)' : 'inherit'
        },
        ...sx
      }}
    >
      {/* card header and action */}
      {title && <CardHeader sx={headerSX} title={title} />}
      {title && <CardHeader sx={headerSX} title={<Typography variant="h3">{title}</Typography>} />}

      {/* content & header divider */}
      {title && <Divider />}

      {/* card content */}
      {content && <CardContent className={contentClass}>{children}</CardContent>}
      {!content && children}
    </Card>
  )
);

MainCard.displayName = 'MainCard';

export default MainCard;
